<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeDemandeImpression.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <a @click="checkPermissions(constantes.DEMANDE_IMPRESSION.maj)
                  ? $router.push({name: 'm.logistique.demande_impression-add'}) : showPopUp()"
                 class="button is-addOrEdit">
                {{ $t('listeDemandeImpression.actions.newDemandeImpression')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="handleAction"
            :options="actions"
            :placeholder="$t('general.placeHolder.groupedAction')"
            :elementsSelectionnes="hasASelection"
            titleButton="general.button.apply">
          </selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('listeDemandeImpression.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class='column is-narrow'>
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            @click="reinitialiser()"
            class="info-circle-right is-pulled-right is-cursor-pointer">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow pr-0">
          <a @click="filterCurrentUser">
        <span class="has-text-primary lien">
          {{  isFilterCurrentUser
            ? $t('listeDemandeImpression.actions.noFilterCurrentUser')
            : $t('listeDemandeImpression.actions.filterCurrentUser') }}
        </span>
          </a>
        </div>
        <div class="column is-narrow pr-0">
          <exportExcelButton
            :perm="constantes.DEMANDE_IMPRESSION.exporter"
            :query="exportExcelQuery"/>
        </div>
        <b-field class="column mg-0">
          <b-checkbox-button
            v-model="withoutImage"
            type="is-primary"
            outlined
            @input="recherche">
            <b-icon
              :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
              class="mg-0">
            </b-icon>
          </b-checkbox-button>
        </b-field>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div v-if="demandeImpressions.length > 0">
      <bloc-resume
        ref="resumeDemandeImpression"
        @changeEtat="changeEtat"
        @changeMaterielTypeLibelle="makeSearchOnMaterialType">
      </bloc-resume>
    </div>
    <div class="tableWithPerPageSelection">
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        :ref="referenceTable"
        @loaded="finLoading"
        @loading="debutLoading"
        class="tableWithChildRow"
        v-if="startArrayRendering && mountedLoadingEnd">
        <template #selected="{ row }">
          <b-checkbox
            :value="row.selected"
            class="has-text-centered"
            @input="selectionDemandeImpression(row)">
          </b-checkbox>
        </template>
        <template #enseigneNomCommercial = "{ row }">
          <router-link-blank
            v-if="row.enseigneId"
            :to="{ name: 'c.bodac.clients/contacts-client', params: { id: row.enseigneId } }"
            :class="{'text-access-no-permission':
              !checkPermissions(constantes.TIERS.lecture)}"
            :message="row.enseigneNomCommercial"
            class="lien">
          </router-link-blank>
        </template>
        <template #typeMateriel = "{ row }" >
          {{ getMaterielTypeLibelles(row.materielTypeLibelles) }}
        </template>
        <template #etats = "{ row }" >
          <div v-for="(etat, index) in getEtatsLibelle(row.etats)" :key="index">
            <b-icon
              icon="checkbox-blank-circle"
              :class="etat.colorClass"
              size="is-small"
            ></b-icon>
            {{ etat.libelle }}
          </div>
        </template>
        <template #prisEnCharge = "{ row }" >
          <qd-button
            v-if="!row.graphistesEnCharge.length"
            @click="applyUpdateGraphistesEnCharge(row)"
            class="button is-primary">
            {{ $t('listeDemandeImpression.updateGraphiste.action')}}
          </qd-button>
          <span v-else> {{ getPrisEnCharge(row.graphistesEnCharge) }} </span>
        </template>
        <template #dateDemande="{row}">
          <section class="columns is-multiline">
            <div class="column is-12">
              {{ formatDate(row.dateDemande)}}
            </div>
            <div class="column is-12 pdt-0">
              <tag-list
                v-if="getTags(row.demandeImpressions).length > 0"
                :listes="getTags(row.demandeImpressions)"/>
            </div>
          </section>
        </template>
        <template #quantite = "{ row }" >
          <div class="is-pulled-right">
            {{ getQuantite(row.demandeImpressions) }}
          </div>
        </template>
        <template #nombreDemande = "{ row }" >
          <div class="is-pulled-right">
            {{ row.demandeImpressions.length }}
          </div>
        </template>
        <template #campagneLibelle = "{ row }">
          <div class="has-text-left">
            <router-link-blank
              v-if="row.campagneId"
              :to="{ name: 'c.bodac.campagne', params: { id: row.campagneId } }"
              :class="{'text-access-no-permission':
                !checkPermissions(constantes.CAMPAGNE.lecture)}"
              :message="row.campagneLibelle"
              class="lien"/>
          </div>
        </template>
        <template #image = "{ row }">
          <div class="has-text-centered">
            <image-view v-if="row.campagneId"
              :permission="constantes.CAMPAGNE"
              :image="row.cheminMin"
              :id="row.campagneId"
              :libelle="row.campagneLibelle || ' '"
              :maxSize="true"
            />
          </div>
        </template>
        <template v-slot:child_row="{ row }">
          <tab-DemandeImpression
            class="overflow-x-auto"
            :data="row"
            @recherche="recherche"
            @actionSelected="selectionDemandeImpressionChild($event, row)">
          </tab-DemandeImpression>
        </template>
      </v-server-table>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-demande-impression
          ref="filtreDemandeImpression"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"
          :value="critereRecherche"/>
      </div>
    </transition>
    <b-modal
      v-model="popUpPrevention"
      @close="popUpPrevention = false"
      class="modal"
      has-modal-card>
      <pop-up-prevention
        :messHeader="$t('listeDemandeImpression.popUpCreationEditionOt.messHeader')"
        :messDescription="$t('listeDemandeImpression.popUpCreationEditionOt.messDescription')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :champsVide="champsVide"
        :messagesPopup="messages"
        :isErrorPopup.sync="error"
        :messagesChampsVide="messagesChampsVide"
        @no="popUpPrevention = false"
        @yes="actionCreationEditionOts">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popUpCamapgne"
      class="modal"
      has-modal-card>
      <popUpUpdateCampagne
        @close="popUpCamapgne = false"
        @update="onUpdateCampagne"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateCampagne>
    </b-modal>
    <b-modal
      v-model="popUpNomFichierRip"
      :width="500"
      class="modal"
      has-modal-card>
      <popUpUpdateNomFichierRip
        @close="popUpNomFichierRip = false"
        @update="onUpdateNomFichierRip"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateNomFichierRip>
    </b-modal>
    <b-modal
      v-model="popUpGraphiste"
      :width="500"
      class="modal"
      has-modal-card>
      <popUpUpdateGraphiste
        @close="popUpGraphiste = false"
        @update="onUpdateGraphiste"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateGraphiste>
    </b-modal>
    <b-modal
      v-model="popUpDate"
      :width="500"
      class="modal"
      has-modal-card>
      <popUpUpdateDate
        @close="popUpDate = false"
        @update="onUpdateDate"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateDate>
    </b-modal>
    <b-modal
      v-model="popUpQuantite"
      :width="500"
      class="modal"
      has-modal-card>
      <popUpUpdateQuantite
        @close="popUpQuantite = false"
        @update="onUpdateQuantite"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateQuantite>
    </b-modal>
    <b-modal
      v-model="popUpEtat"
      class="modal"
      has-modal-card>
      <popUpUpdateEtat
        @close="popUpEtat = false"
        @update="onUpdateEtat"
        :demandeImpressions="demandesSelected"
      ></popUpUpdateEtat>
    </b-modal>
    <b-modal
      v-model="popUpPreventionUpdateGraphiste"
      @close="popUpPreventionUpdateGraphiste = false"
      class="modal"
      has-modal-card>
      <pop-up-prevention
        :messHeader="$t('listeDemandeImpression.updateGraphiste.popupTitle')"
        :messDescription="$t('listeDemandeImpression.updateGraphiste.popupDescription')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :champsVide="champsVide"
        :messagesPopup="messages"
        :isErrorPopup.sync="error"
        :messagesChampsVide="messagesChampsVide"
        @no="popUpPreventionUpdateGraphiste = false"
        @yes="actionSetGraphistesEnCharge">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import uniq from 'lodash/uniq';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import edition from '@/api/edition/index';
import { updateGraphisteEnChargeAllAsync } from '@/api/logistique/demandeImpression/demandeImpressionRegroupement';
import { createOTs } from '@/api/logistique/demandeImpression/index';
import breadcrumb from '@/components/general/breadcrumb';
import formatIsoDate from '@/services/general/formatIsoDate';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_DEMANDE_IMPRESSION } from '@/configuration/general/referenceTableConf';
import { SET_CRITERES } from '@/store/modules/logistique/demandeImpression-mutation-type';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { SET_LOCK_MENU, SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import filtreListeDemandeImpression from '@/components/logistique/demandeImpression/filtreListeDemandeImpression';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { columnsSplice } from '@/services/general/columns';
import { CAMPAGNE, TIERS } from '@/configuration/permissionsBodacConf';
import imageView from '@/components/general/imageView';
import tabDemandeImpression from '@/components/logistique/demandeImpression/liste/tabDemandeImpression';
import blocResume from '@/components/logistique/demandeImpression/liste/blocResume';
import selecteurAction from '@/components/general/selecteurAction';
import popUpPrevention from '@/components/general/popUpPrevention';
import subscribeMutation from '@/services/store/subscribeMutation';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { DEMANDE_IMPRESSION, ORDRE_TRAVAIL_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  ACTION_MASS_CREATION_EDITION_OT,
  ACTION_UPDATE_CAMPAGNE,
  ACTION_UPDATE_ETAT,
  ACTION_UPDATE_NOM_FICHIER_RIP,
  ACTION_UPDATE_GRAPHISTE,
  ACTION_UPDATE_DATE,
  ACTION_UPDATE_QUANTITE,
  ETAT_DEMANDE_IMPRESSION,
  COULEUR_ETAT_DEMANDE_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/ordreTravail/tech/validation/translate';
import validationOTTech from '@/services/logistique/ordreTravail/tech/validation/validation';
import validationDemandeImpression from '@/services/logistique/demandeImpression/validationDemandeImpression';
import popUpUpdateCampagne from '@/components/logistique/demandeImpression/popUpUpdateCampagne';
import popUpUpdateEtat from '@/components/logistique/demandeImpression/popUpUpdateEtat';
import popUpUpdateNomFichierRip from '@/components/logistique/demandeImpression/popUpUpdateNomFichierRip';
import popUpUpdateGraphiste from '@/components/logistique/demandeImpression/popUpUpdateGraphiste';
import popUpUpdateDate from '@/components/logistique/demandeImpression/popUpUpdateDate';
import popUpUpdateQuantite from '@/components/logistique/demandeImpression/popUpUpdateQuantite';
import formatDate from '@/services/general/formatDate';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import tagList from '@/components/general/tagList';

const Permissions = createNamespacedHelpers('permissions');
const DemandeImpression = createNamespacedHelpers('demandeImpression');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const user = createNamespacedHelpers('user');

export default {
  name: 'l_demandeImpression',
  data() {
    return {
      constantes: {
        DEMANDE_IMPRESSION,
        CAMPAGNE,
        TIERS,
      },
      formatDate,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_DEMANDE_IMPRESSION,
      popUpPrevention: false,
      mountedLoadingEnd: false,
      resultPerPage: RESULTS_PER_PAGE,
      showFiltre: false,
      withoutImage: true,
      unsubscribeValue: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      popUpCamapgne: false,
      popUpEtat: false,
      popUpPreventionUpdateGraphiste: false,
      regroupementSelected: null,
      popUpGraphiste: false,
      popUpNomFichierRip: false,
      popUpDate: false,
      popUpQuantite: false,
    };
  },
  components: {
    breadcrumb,
    parametrageTable,
    exportExcelButton,
    filtreListeDemandeImpression,
    RouterLinkBlank,
    imageView,
    tabDemandeImpression,
    blocResume,
    selecteurAction,
    popUpPrevention,
    popUpUpdateCampagne,
    popUpUpdateEtat,
    popUpUpdateNomFichierRip,
    popUpUpdateGraphiste,
    popUpUpdateDate,
    popUpUpdateQuantite,
    tagList,
  },
  methods: {
    ...DemandeImpression.mapActions({
      loadDemandeImpression: 'loadDemandeImpressionView',
    }),
    ...DemandeImpression.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_CREATION_EDITION_OT:
          this.applyMassCreationEditionOt();
          break;
        case ACTION_UPDATE_CAMPAGNE:
          this.popUpCamapgne = true;
          break;
        case ACTION_UPDATE_GRAPHISTE:
          this.popUpGraphiste = true;
          break;
        case ACTION_UPDATE_NOM_FICHIER_RIP:
          this.popUpNomFichierRip = true;
          break;
        case ACTION_UPDATE_DATE:
          this.popUpDate = true;
          break;
        case ACTION_UPDATE_QUANTITE:
          this.popUpQuantite = true;
          break;
        case ACTION_UPDATE_ETAT:
          this.popUpEtat = true;
          break;
        default:
          break;
      }
    },
    applyMassCreationEditionOt() {
      if (!this.checkPermissions(ORDRE_TRAVAIL_IMPRESSION.editer)
       || !this.checkPermissions(ORDRE_TRAVAIL_IMPRESSION.maj)) {
        this.showPopUp();
        return;
      }
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.popUpPrevention = true;
    },
    async reinitialiser() {
      await this.$refs.filtreDemandeImpression.initializeFiltre();
      this.$refs.filtreDemandeImpression.viderCritere();
      this.$refs.filtreDemandeImpression.appliquerCritere();
      this.showFiltre = false;
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
      this.$refs.resumeDemandeImpression.getInfos();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreDemandeImpression.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter(critereUpdate) {
      this.setCritereRecherche(critereUpdate);
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    getMaterielTypeLibelles(materielTypes) {
      return materielTypes.map(el => el).join(', ');
    },
    changeEtat(etat) {
      this.critereRecherche.etats = [etat];
      this.recherche();
    },
    makeSearchOnMaterialType(data) {
      this.critereRecherche.etats = [data.etat];
      this.critereRecherche.materielTypeLibelles = [data.materielTypeLibelle];
      this.recherche();
    },
    getPrisEnCharge(graphistes) {
      return graphistes
        .join(', ');
    },
    getQuantite(demandes) {
      return demandes.reduce((acc, demande) => {
        return acc + demande.quantite;
      }, 0);
    },
    getCouleurEtat(etatDemande) {
      return COULEUR_ETAT_DEMANDE_IMPRESSION.find(etat => etat.key === etatDemande);
    },
    getEtatsLibelle(etats) {
      return etats
        .map(etatEnum => {
          const etat = ETAT_DEMANDE_IMPRESSION.find(etatDemandeImpression => {
            return etatEnum.toLowerCase() === etatDemandeImpression.key.toLowerCase();
          });
          if (etat) {
            return {
              libelle: etat.libellei18n,
              colorClass: this.getCouleurEtat(etatEnum).type,
            };
          }
          return null;
        })
        .filter(etat => etat !== null);
    },
    filterCurrentUser() {
      this.$set(this.critereRecherche, 'graphisteIds', this.isFilterCurrentUser ? [] : [this.utilisateur.id]);
      this.recherche();
      this.showFiltre = false;
    },
    selectAll() {
      const selectAllValue = !this.demandeImpressions.every(e => e.selected);
      this.demandeImpressions.forEach((e) => {
        e.selected = selectAllValue;
        e.demandeImpressions.forEach((ot) => { ot.selected = selectAllValue; });
      });
    },
    selectionDemandeImpression(row) {
      this.demandeImpressions.forEach((e) => {
        if (e.id === row.id) {
          e.selected = !e.selected;
          e.demandeImpressions.forEach((ot) => { ot.selected = e.selected; });
        }
      });
    },
    selectionDemandeImpressionChild(child, row) {
      row.demandeImpressions.forEach((e) => {
        if (e.id === child.id) e.selected = !child.selected;
      });
      row.selected = row.demandeImpressions.every((e) => e.selected);
    },
    async actionCreationEditionOts() {
      const loadingComponent = this.$buefy.loading.open();
      const demandesSelected = this.demandeImpressions
        .flatMap(d => d.demandeImpressions.filter(ot => ot.selected));
      const createOt = demandesSelected
        .filter(d => !d.otIds.length)
        .map(d => d.id);
      try {
        const otIds = !createOt.length ? [] : (await createOTs(createOt)).data.result;
        const editionOts = demandesSelected.filter(d => d.otIds.length).flatMap(d => d.otIds);
        const otIdsToEdition = uniq(otIds.concat(editionOts));
        if (otIdsToEdition.length) {
          await this.editionOrdreTravail(otIdsToEdition);
        }
        this.popUpPrevention = false;
        this.recherche();
      } catch (e) {
        if (e.response?.data?.error) {
          validationOTTech(e.response, this.messages);
          validationDemandeImpression(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async editionOrdreTravail(otsIds) {
      try {
        const response = await edition({
          ids: otsIds,
          extension: TYPE_PDF,
          typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
    onUpdateCampagne() {
      this.popUpCamapgne = false;
      this.recherche();
    },
    onUpdateEtat() {
      this.popUpEtat = false;
      this.recherche();
    },
    onUpdateNomFichierRip() {
      this.popUpNomFichierRip = false;
      this.recherche();
    },
    onUpdateGraphiste() {
      this.popUpGraphiste = false;
      this.recherche();
    },
    onUpdateDate() {
      this.popUpDate = false;
      this.recherche();
    },
    onUpdateQuantite() {
      this.popUpQuantite = false;
      this.recherche();
    },
    applyUpdateGraphistesEnCharge(row) {
      if (!this.checkPermissions(DEMANDE_IMPRESSION.maj)) {
        this.showPopUp();
        return;
      }
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.regroupementSelected = row;
      this.popUpPreventionUpdateGraphiste = true;
    },
    async actionSetGraphistesEnCharge() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateGraphisteEnChargeAllAsync({
          regroupementId: this.regroupementSelected.id,
        });
        messageSuccess(this.$t('listeDemandeImpression.updateGraphiste.messageSuccess'));
        this.recherche();
        this.regroupementSelected = null;
        this.popUpPreventionUpdateGraphiste = false;
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getTags(demandes) {
      const tagIds = [...new Set(demandes.flatMap(d => d.tagIds))];
      return this.parametre(PARAMETRES_KEYS.tag).filter((tag) => {
        return tagIds.includes(tag.id);
      });
    },
  },
  computed: {
    ...DemandeImpression.mapGetters({
      demandeImpressions: 'demandeRegroupements',
      totalCount: 'demandeRegroupementTotal',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    breadcrumb() {
      return [
        {
          title: this.$t('listeDemandeImpression.breadcrumb.home'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        {
          title: this.$t('listeDemandeImpression.breadcrumb.listeDemandeImpression'),
          route: '',
          isActive: true,
        },
      ];
    },
    columns() {
      const allColumns = [
        'selected',
        'dateDemande',
        'enseigneNomCommercial',
        'campagneLibelle',
        'typeMateriel',
        'etats',
        'quantite',
        'nombreDemande',
        'prisEnCharge',
        'image',
      ];
      if (this.withoutImage) columnsSplice(allColumns, 'image');
      return allColumns;
    },
    iconSelectTotal() {
      if (this.demandeImpressions.every(item => item.demandeImpressions.every(ot => ot.selected))) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    hasASelection() {
      return this.demandeImpressions.some(d => d.demandeImpressions.some(otImp => otImp.selected));
    },
    demandesSelected() {
      return this.demandeImpressions
        .flatMap(d => d.demandeImpressions.filter(ot => ot.selected));
    },
    isFilterCurrentUser() {
      if (this.critereRecherche.graphisteIds?.length === 1
        && this.critereRecherche.graphisteIds[0] === this.utilisateur.id) {
        return true;
      }
      return false;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          enseigneNomCommercial: this.$t('listeDemandeImpression.tabs.enseigne'),
          campagneLibelle: this.$t('listeDemandeImpression.tabs.campagne'),
          typeMateriel: this.$t('listeDemandeImpression.tabs.materielType'),
          etats: this.$t('listeDemandeImpression.tabs.etats'),
          nombreDemande: this.$t('listeDemandeImpression.tabs.nombreDemande'),
          quantite: this.$t('listeDemandeImpression.tabs.quantite'),
          prisEnCharge: this.$t('listeDemandeImpression.tabs.prisEnCharge'),
          image: this.$t('listeDemandeImpression.tabs.visuelCampagne'),
          dateDemande: this.$t('listeDemandeImpression.tabs.dateDemande'),
          selected: (h) => {
            return h(
              'a', {
                attrs: { class: 'pointer' },
                on: { click: this.selectAll },
              },
              [h('b-icon', { attrs: { icon: this.iconSelectTotal } })],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.dates.dateDebut && data.query.dates.dateFin) {
            data.query.dates.dateDebut = formatIsoDate(
              data.query.dates.dateDebut,
            );
            data.query.dates.dateFin = formatIsoDate(
              data.query.dates.dateFin,
            );
          }
          return this.loadDemandeImpression(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.demandeImpressions,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          image: 'width-50-percent',
        },
        sortable: ['enseigneNomCommercial', 'campagneLibelle', 'dateDemande'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'demandeimpression',
        typeExport: '',
        filtres: {
          ...this.lastPayload,
        },
      };
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'societeId', 'societe'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (!this.critereRecherche.dates.dateDebut && !this.critereRecherche.dates.dateFin) {
        nbCritere -= 1;
      }
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    actions() {
      return [
        {
          action: ACTION_MASS_CREATION_EDITION_OT,
          translation: 'listeDemandeImpression.actions.creationEditionOt',
        },
        {
          action: ACTION_UPDATE_CAMPAGNE,
          translation: 'listeDemandeImpression.actions.updateCampagne',
        },
        {
          action: ACTION_UPDATE_ETAT,
          translation: 'listeDemandeImpression.actions.updateEtat',
        },
        {
          action: ACTION_UPDATE_NOM_FICHIER_RIP,
          translation: 'listeDemandeImpression.actions.updateNomFichierRip',
        },
        {
          action: ACTION_UPDATE_GRAPHISTE,
          translation: 'listeDemandeImpression.actions.updateGraphiste',
        },
        {
          action: ACTION_UPDATE_DATE,
          translation: 'listeDemandeImpression.actions.updateDate',
        },
        {
          action: ACTION_UPDATE_QUANTITE,
          translation: 'listeDemandeImpression.actions.updateQuantite',
        },
      ];
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.tag]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageDemandeImpression.liste'));
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw error;
    }
  },
};
</script>
